// registerFace.js
import React, { useRef, useEffect, useState } from 'react';
import * as faceapi from 'face-api.js';
import { loadModels } from '../screens/public/face/faceUtils';
import { apiRequest } from '../service/apiRequest';

const RegisterFace = () => {
  const videoRef = useRef();
  const canvasRef = useRef();
  const [label, setLabel] = useState('');
  const [message, setMessage] = useState('');

  useEffect(() => {
    const startVideo = async () => {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({ video: true });
        videoRef.current.srcObject = stream;
      } catch (error) {
        console.error('Error accessing webcam:', error);
      }
    };

    const init = async () => {
      await loadModels();
      startVideo();
    };

    init();

    return () => {
      if (videoRef.current?.srcObject) {
        videoRef.current.srcObject.getTracks().forEach(track => track.stop());
      }
    };
  }, []);

  const captureFace = async () => {
    if (!label) {
      alert('Please enter a label (name) for this face');
      return;
    }

    const detection = await faceapi
      .detectSingleFace(videoRef.current, new faceapi.SsdMobilenetv1Options())
      .withFaceLandmarks()
      .withFaceDescriptor();

    if (!detection) {
      alert('No face detected. Please try again.');
      return;
    }

    const descriptorArray = Array.from(detection.descriptor); // Convert Float32Array to normal array

    const payload = {
      label: label.trim(),
      descriptors: JSON.stringify([descriptorArray]), // ✅ Correct key: "descriptors"
    };

    try {
      await apiRequest({
        method: 'post',
        url: 'http://192.168.0.103:9998/api/register-face',
        data: payload,
      });
      setMessage(`✅ Face registered for: ${label}`);
    } catch (err) {
      console.error('❌ Failed to register face:', err);
      setMessage('❌ Face registration failed.');
    }
  };

  return (
    <div>
      <h2>Register New Face</h2>
      <video ref={videoRef} autoPlay muted width="720" height="560" />
      <canvas ref={canvasRef} style={{ position: 'absolute', top: 0, left: 0 }} />
      <input
        type="text"
        placeholder="Enter name"
        value={label}
        onChange={(e) => setLabel(e.target.value)}
      />
      <button onClick={captureFace}>Capture & Register Face</button>
      <p>{message}</p>
    </div>
  );
};

export default RegisterFace;
